export default __webpack_public_path__ + "static/media/mortarboard.ce561771.svg";